import { Button, Flex, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import Textarea from "../inputs/Textarea";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

type DeleteOrderFormProps = {
  id?: number;
  onSubmit?: (data: { status: string, explanation: string }) => void;
  onClose?: () => void;
};

const haltSchema = z.object({
  explanation: z.string().min(1, { message: "Ce champ est requis." }),
});

function DeleteOrderForm({ onSubmit, onClose }: DeleteOrderFormProps) {
  const methods = useForm({
    resolver: zodResolver(haltSchema),
  });

  const resetFormFields = async () => {
    methods.reset({
      explanation: "",
    });
  };
  const handleSubmit = async () => {
    const valid = await methods.trigger();
    if (valid && onSubmit) {
      const { explanation } = methods.getValues()
      onSubmit({
        status: 'ABORTED', explanation
      });
      resetFormFields();
    }
  };
  return (
    <FormProvider {...methods}>
      <form style={{ marginTop: "32px", marginBottom: "32px" }}>
        <FormControl isInvalid={!!methods.formState.errors.explanation}>
          <Textarea
            id="explanation"
            placeholder="Explication"
            mt={4}
            {...methods.register("explanation")}
          ></Textarea>
          <FormErrorMessage>
            <>{methods.formState.errors?.explanation?.message}</>
          </FormErrorMessage>
        </FormControl>

        <Flex mt={3} pt={3} justifyContent={"end"} w='100%'>
          <Button w={"fit-content"} mr={4} onClick={onClose}>Annuler</Button>
          <Button w={"fit-content"} onClick={handleSubmit} bgColor="red" color='white'>Annuler la commande</Button>
        </Flex>
      </form>
    </FormProvider>
  );
}

export default DeleteOrderForm;
